import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Grid, Row } from 'react-bootstrap';
import './UserInvitations.css';
import ShowInvitation from './ShowInvitation';
import { Link } from 'react-router-dom';

class UserInvitationsSent extends Component {
  static propTypes = {
    invitations: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        email: PropTypes.string,
        permissions: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.number,
            label: PropTypes.string,
            selected: PropTypes.bool,
          })
        ),
      })
    ),
    onRemove: PropTypes.func,
  };

  handleInvitationRemove = (id) => {
    this.props.onRemove(id);
  };

  render() {
    return (
      <div className="user-invitations client">
        <Grid>
          <Row>
            <Col lg={6} lgOffset={3}>
              <div className="title">
                <span>Invites Sent</span>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg={6} lgOffset={3}>
              <div className="subtitle">
                <span>
                  You will be notified when the user accepts your invite.
                </span>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg={10} lgOffset={1}>
              {this.props.invitations.map((invitation) => (
                <ShowInvitation
                  user={invitation}
                  onDelete={this.handleInvitationRemove}
                  key={invitation.id}
                />
              ))}
            </Col>
          </Row>

          <Row>
            <Col lg={6} lgOffset={3}>
              <div className="button-container">
                <Link to={'/'}>
                  <button className={'btn btn-select btn-orange'}>
                    Go to Dashboard
                  </button>
                </Link>
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default UserInvitationsSent;



// WEBPACK FOOTER //
// ./src/components/client/user-invitations/UserInvitationsSent.js